import { Head } from '@inertiajs/react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import type { AdminCredentialsIndex } from '@/types';
import { CreateCredentialDialog } from './components/CreateCredentialDialog';
import { CredentialsSearch } from './components/CredentialsSearch';
import { CredentialsTable } from './components/CredentialsTable';

export default function Index({
  title,
  eventSlug,
  eventName,
  search,
  credentials,
  stats,
  assignableOptions,
  credentialTypes,
}: AdminCredentialsIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-bold text-3xl tracking-tight">Credentials</h1>
            <p className="text-muted-foreground">
              Printed cards for {eventName} and who they belong to
            </p>
          </div>
          <CreateCredentialDialog
            eventSlug={eventSlug}
            assignableOptions={assignableOptions}
            credentialTypes={credentialTypes}
          />
        </div>

        <Card>
          <CardHeader className="gap-4">
            <div className="flex items-center gap-6 text-sm">
              <div>
                <span className="text-muted-foreground">Printed: </span>
                <span className="font-semibold">{stats.total}</span>
              </div>
              <div>
                <span className="text-muted-foreground">Assigned: </span>
                <span className="font-semibold">{stats.assigned}</span>
              </div>
              <div>
                <span className="text-muted-foreground">Unassigned: </span>
                <span className="font-semibold">{stats.unassigned}</span>
              </div>
            </div>
            <CredentialsSearch eventSlug={eventSlug} search={search} />
            <p className="text-muted-foreground text-sm">
              {credentials.length}{' '}
              {credentials.length === 1 ? 'credential' : 'credentials'} shown
            </p>
          </CardHeader>
          <CardContent className="p-0">
            <CredentialsTable
              eventSlug={eventSlug}
              credentials={credentials}
              assignableOptions={assignableOptions}
              credentialTypes={credentialTypes}
            />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
